/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { PatchedLocationDescriptor } from 'js/lib/connectToRouter';

import { LeftPanel } from './LeftPanel';
import TopBar from './TopBar';

const styles = {
  gradingFullScreenWrapper: css`
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    transform: translateZ(0);
    bottom: 0;
    max-width: 100%;
    max-height: 100%;
    z-index: 4000;
    background-color: var(--cds-color-white-0);
    box-shadow: rgb(0 0 0 / 20%) 0 0 3em 1em;
    overflow: hidden;
  `,
  sgaGradingPanelContainer: css`
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    height: calc(100% - 64px);
    max-height: calc(100% - 64px);
  `,
};

type Props = {
  routeOnClose: PatchedLocationDescriptor;
  topBarComponent: React.ReactNode;
  exitButtonOverrideComponent?: React.ReactNode;
  leftPanelComponent?: React.ReactNode;
  contentPanelComponent: React.ReactNode;
};

const GradingFullScreenWrapper = ({
  routeOnClose,
  topBarComponent,
  exitButtonOverrideComponent,
  leftPanelComponent,
  contentPanelComponent,
}: Props) => {
  return (
    <div role="dialog" aria-modal="true" data-testid="grading-item-wrapper" css={styles.gradingFullScreenWrapper}>
      <TopBar routeOnClose={routeOnClose} exitButtonOverrideComponent={exitButtonOverrideComponent}>
        {topBarComponent}
      </TopBar>
      <div css={styles.sgaGradingPanelContainer}>
        {leftPanelComponent && <LeftPanel>{leftPanelComponent}</LeftPanel>}
        {contentPanelComponent}
      </div>
    </div>
  );
};

export default GradingFullScreenWrapper;
